import { useState, useEffect } from 'react';
import { Article } from '@/types/article';
import { getArticles } from '@/services/articleService';

export const useArticles = (params?: {
  page?: number;
  limit?: number;
  category?: string;
  tag?: string;
}) => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        const { articles: fetchedArticles } = await getArticles(params);
        setArticles(fetchedArticles);
      } catch (err) {
        console.error('Error fetching articles:', err);
        setError('Failed to load articles. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchArticles();
  }, [params]);

  return { articles, isLoading, error };
}; 